import MatchRect from 'lib/match-rect';

export default function init_feather_icon() {
    const featherIconWrappers = document.querySelectorAll<HTMLElement>('.feather-icon-overlay .match-block-height');

    for (const target of featherIconWrappers) {
        const section = target?.parentElement?.nextElementSibling;

        if (section) {
            const source = (section.querySelector('.feather-overlay-source') ?? section) as HTMLElement;

            new MatchRect({
                target,
                source,
                rectProps: 'height'
            });
        }
    }
}